import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

enum DocumentDownloadStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PROCESSING = 'processing',
  WAITING = 'waiting',
}

interface GetDocumentDownloadResponse {
  createdAt: string;
  id: string;
  memo: string;
  status: DocumentDownloadStatus;
  updatedAt: string;
  urls: string[] | null;
  user: {
    email: string;
    id: string;
    name: string;
  };
}

/**
 * 문서 일괄 다운로드 정보 조회하는 API 호출
 */
// eslint-disable-next-line import/prefer-default-export
export function getDocumentDownload(
  documentDownloadId: string
): Promise<Pick<GetDocumentDownloadResponse, 'urls'>> {
  return requestApi<GetDocumentDownloadResponse>({
    url: withDocument(`/document-downloads/${documentDownloadId}`),
    method: 'GET',
    credentials: true,
  }).then((response) => ({
    urls: response.data.urls,
  }));
}
